
import React, { useState } from 'react';
import { Container, Box, Button, Typography, Collapse, Divider } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const answerSx = {
  fontFamily: 'GillSansSemiBold, Arial, sans-serif',
  fontSize: { xs: '3.2vw', sm: '2vw', md: '1vw' },
  color: '#333',
  lineHeight: 1.7,
};

const FAQ_DATA = [
  {
    question: 'What is the launch date of MG Majestor?',
    answer: 'The official launch date for the MG Majestor is 12th February 2026.',
  },
  {
    question: 'What segment does the car compete in?',
    answer: 'The new MG Majestor is positioned in the D+ Segment, setting benchmarks as the tallest, widest, and longest vehicle in its class.',
  },
  {
    question: 'When is the car available for test drive?',
    answer: "Test drives will be announced shortly after the launch. We will notify all interested customers through our official channels once scheduling opens, ensuring you're among the first to experience the new model.",
  },
  {
    question: 'What do you mean by pre-reserve?',
    answer: 'The car is getting launched on 12th Feb and all the details will be shared then. Please watch the launch and check our official social channels for time and link of the launch.',
  },
  {
    question: 'When are you opening the bookings?',
    answer: "The car is getting launched on 12th Feb. We will notify all interested customers through our official channels once booking opens, ensuring you're among the first to experience the new model.",
  },
  {
    question: 'What is the booking amount? Will it be refundable?',
    answer: "We will notify all interested customers through our official channels once booking opens, ensuring you're among the first to experience the new model.",
  },
  {
    question: 'How can I book the MG Majestor?',
    answer: "The car is getting launched on 12th Feb and all the details will be shared then. We will notify all interested customers through our official channels once booking opens, ensuring you're among the first to experience the new model.",
  },
  {
    question: 'Will there be a waiting time for the MG Majestor?',
    answer: 'The car is getting launched on 12th Feb and all the details will be shared then. Please watch the launch and check our official social channels for time and link of the launch.',
  },
  {
    question: 'What is the price of MG Majestor?',
    answer: 'The car is getting launched on 12th Feb and all the details will be shared then.',
  },
  {
    question: 'When will the deliveries start?',
    answer: 'The official launch date for the MG Majestor is 12th February 2026 and all the details will be shared then.',
  },
  {
    question: 'Will you discontinue the MG Gloster?',
    answer: 'No, the MG Gloster will continue to be available. The MG Majestor operates in a segment above, offering a more premium positioning while complementing the Gloster in our SUV lineup.',
  },
  {
    question: 'Is the car available in All Wheel Drive or 4 Wheel Drive?',
    answer: 'The car is getting launched on 12th Feb and all the details will be shared then.',
  },
  {
    question: "How is the MG Majestor better than the MG Gloster? What's new in MG Majestor?",
    answer: 'The MG Majestor is positioned above the MG Gloster, in the premium D+ Segment. The official launch date for the MG Majestor is 12th February 2026 and all the details will be shared then.',
  },
  {
    question: 'Is the MG Majestor positioned above MG Gloster or alongside it?',
    answer: 'The MG Majestor is positioned above the MG Gloster, in the premium D+ Segment. It represents a higher category with enhanced dimensions while Gloster continues to serve its own segment.',
  },
  {
    question: 'What drivetrain does MG Majestor use in the 2WD trims?',
    answer: 'The car is getting launched on 12th Feb and all the details will be shared then. Please watch the launch and check our official social channels for time and link of the launch.',
  },
  {
    question: 'Which SUVs will the MG Majestor compete with?',
    answer: 'The MG Majestor stands in a league of its own. Positioned in the exclusive D+ SUV segment, it is currently the only SUV of its kind in India. With its commanding stance, expansive dimensions, and rich features, it sets a new benchmark for premium full-size SUVs rather than competing directly with others.',
  },
  {
    question: 'MG Majestor will be offered with how many seating configurations?',
    answer: 'The MG Majestor will be offered in two seating configurations — a 6-seater with captain seats in the second row (2+2+2 layout) for enhanced comfort and luxury, and a 7-seater with a bench seat in the second row (2+3+2 layout) to maximize practicality and accommodate more passengers.',
  },
  {
    question: 'Is the MG Majestor available in Petrol & Diesel both?',
    answer: 'The MG Majestor is offered only with a diesel engine. It features a 2.0L twin-turbo diesel producing 215.5 PS and 478.5 Nm, paired with an 8-speed automatic transmission for strong performance and smooth cruising.',
  },
  {
    question: 'What are the technical highlights of the MG Majestor?',
    answer: 'The MG Majestor is powered by a 2.0L twin-turbo diesel engine paired with an 8-speed automatic transmission, delivering 215.5 PS of power and boasts segment-leading proportions — 5046 mm length, 2016 mm width, 1870 mm height, and a 2950 mm wheelbase for unmatched presence.',
  },
  {
    question: 'What are the new feature highlights of the MG Majestor?',
    answer: (
      <Box>
        <Typography sx={{ ...answerSx, mb: 1 }}>
          The MG Majestor comes packed with standout features such as:
        </Typography>
        {[
          'An imposing stance with class-leading dimensions — tallest, widest, and longest in its segment',
          'Advanced Select 4x4 system with 10 terrain modes (sand, snow, mud, rock, and more)',
          'M-Lounge front seats offering multi-mode massage and ventilation',
          'Galaxy view roof for an expansive cabin experience',
          'Twin-turbo diesel engine paired with an 8-speed automatic transmission',
        ].map((point, i) => (
          <Box key={i} sx={{ display: 'flex', gap: '10px', mb: '4px' }}>
            <Typography sx={{ ...answerSx, color: '#000', fontWeight: 700, flexShrink: 0 }}>
              {['i.', 'ii.', 'iii.', 'iv.', 'v.'][i]}
            </Typography>
            <Typography sx={answerSx}>{point}</Typography>
          </Box>
        ))}
      </Box>
    ),
  },
  {
    question: 'What transmission options will be offered in MG Majestor?',
    answer: 'The MG Majestor comes with a single option — a refined 8-speed automatic (8AT) paired with the 2.0L twin-turbo diesel engine, delivering smooth shifts and strong performance.',
  },
  {
    question: 'What is the tyre size in the MG Majestor?',
    answer: "The MG Majestor comes equipped with 265/55 R19 tyres. This size offers a perfect balance of robust road grip, stability, and comfort, complementing the SUV's commanding stance and premium driving dynamics.",
  },
  {
    question: 'What engine specification will be offered with MG Majestor?',
    answer: 'The MG Majestor is driven by a 2.0L twin-turbo diesel engine producing 215.5 PS and 478.5 Nm, paired with a smooth 8-speed automatic (8AT) ensuring strong performance, refined driving dynamics, and effortless cruising capability.',
  },
  {
    question: 'Would the car be available for commercial registration?',
    answer: 'The MG Majestor is not currently available for commercial registration. At present, it is offered exclusively for private ownership, with no commercial registration option.',
  },
  {
    question: 'What does D+ Segment mean?',
    answer: 'The "D+ Segment" refers to a new category of SUVs that go beyond the traditional D-segment in terms of size, stance, and features. The MG Majestor is positioned as India\'s first D+ SUV, meaning it is longer, wider, taller, and more premium than existing full-size SUVs.',
  },
  {
    question: 'Does the car have iSwipe just like Hector?',
    answer: 'No, the MG Majestor does not feature i-Swipe.',
  },
  {
    question: 'Will the MG Majestor be built on a Monocoque or Ladder Frame chassis?',
    answer: 'The MG Majestor is constructed on a ladder frame chassis, ensuring durability, strength, and superior off-road capability.',
  },
  {
    question: 'Does it come with a Hybrid system?',
    answer: 'No, the MG Majestor does not come with a hybrid system. It is offered exclusively with a powerful 2.0L twin-turbo diesel engine paired to an 8-speed automatic transmission.',
  },
  {
    question: 'What is the Torque and Power of the Vehicle?',
    answer: 'The MG Majestor delivers an impressive 215.5 PS of power and 478.5 Nm of torque from its 2.0L twin-turbo diesel engine. This ensures strong performance, effortless cruising, and commanding driving dynamics befitting a premium D+ segment SUV.',
  },
  {
    question: 'How many airbags does it have?',
    answer: 'The MG Majestor is equipped with 6 airbags, providing comprehensive safety coverage for all occupants and enhancing protection in the event of a collision.',
  },
  {
    question: 'What are the color options available?',
    answer: 'The MG Majestor will be offered in four premium color options: Pearl White, Concrete Grey, Metal Black, and Metal Ash. These shades have been carefully curated to complement its bold design and commanding road presence.',
  },
  {
    question: 'How many variants are there?',
    answer: (
      <Box>
        <Typography sx={{ ...answerSx, mb: 1 }}>
          The MG Majestor will be offered in three variants:
        </Typography>
        {['Sharp 2WD', 'Savvy 2WD', 'Savvy 4WD'].map((variant, i) => (
          <Box key={i} sx={{ display: 'flex', gap: '10px', mb: '4px' }}>
            <Typography sx={{ ...answerSx, color: '#000', fontWeight: 700, flexShrink: 0 }}>•</Typography>
            <Typography sx={answerSx}>{variant}</Typography>
          </Box>
        ))}
        <Typography sx={{ ...answerSx, mt: 1 }}>
          This lineup provides buyers with options ranging from a well-equipped rear-wheel-drive model to a fully loaded 4WD variant for enhanced capability.
        </Typography>
      </Box>
    ),
  },
  {
    question: 'What is the size of infotainment Screen?',
    answer: 'The MG Majestor features a 12.3-inch HD portrait Infotainment Screen. This advanced&nbsp;display provides a modern, high-resolution interface for vehicle information, enhancing&nbsp;both convenience and the premium feel of the cabin.',
  },
  {
    question: 'What are the various driving modes in the Majestor?',
    answer: 'The MG Majestor is equipped with Advanced 4x4 with 10 offroad modes. This&nbsp;advanced system ensures optimal performance and control across diverse road and&nbsp;off-road conditions, giving drivers confidence whether on highways, city roads, or&nbsp;rugged terrains.',
  },
  {
    question: ' How much is the ground clearance? Would I be able to drive it above the  bumpy roads?',
    answer: 'The MG Majestor offers a generous 219 mm of ground clearance. This high clearance&nbsp;ensures that the SUV can easily tackle uneven terrain, speed breakers, and bumpy&nbsp;roads without scraping the underbody, making it well-suited for both city drives and&nbsp;adventurous journeys.',
  },
  {
    question: 'Does it have Differential Lock?',
    answer: 'Yes, the MG Majestor is equipped with a Triple Differential Lock system — covering&nbsp;the front, central, and rear differentials. It also features mCrawl technology, which&nbsp;enhances low-speed control and traction on challenging terrains, making it highly&nbsp;capable for serious off-road adventures.',
  },
  {
    question: 'How many connected car features does it have?',
    answer: 'The MG Majestor offers 75+ connected car features, including remote controls, live&nbsp;navigation, voice commands, and smart alerts — making it one of the most tech-savvy&nbsp;SUVs in its class.',
  },
  {
    question: 'Is the car suitable for highway drives?',
    answer: 'Yes, the MG Majestor is ideal for highways. Its 2.0L twin-turbo diesel engine (215.5 PS,&nbsp;478.5 Nm) with 8AT ensures effortless cruising, while the long wheelbase, 219 mm&nbsp;ground clearance, advanced suspension, ADAS, and 75+ connected features provide&nbsp;stability, comfort, and safety on long journeys.',
  },
  {
    question: 'I had heard that in near future the Petrol would be E27, Is the E27 Petrol  compliant',
    answer: 'The MG Majestor is offered only with a diesel engine, so petrol compatibility&nbsp;(including E27 blends) does not apply.',
  },
  {
    question: 'What is the NCAP rating of MG Majestor?',
    answer: 'The MG Majestor has not yet been tested by Euro NCAP, Global NCAP, or Bharat&nbsp;NCAP (BNCAP), so no official crash safety rating is currently available. While the SUV&nbsp;does not have a published star rating, it is equipped with safety features such as 6&nbsp;airbags, EPB, Level 2 ADAS, 360 Degree camera &amp; more.',
  },
];

function QuestionBox({ question, answer, expanded, onToggle }) {
  return (
    <Box>
      <Box
        onClick={onToggle}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: 'pointer',
          py: '10px',
          px: '10px',
          borderRadius: '4px',
          
        }}
      >
        <Typography
          sx={{
            fontFamily: 'GillSansSemiBold, Arial, sans-serif',
            fontSize: { xs: '3.8vw', sm: '2.4vw', md: '1.2vw' },
            color: '#000',
            fontWeight: 700,
            lineHeight: 1.4,
            pr: 2,
            flex: 1,
          }}
        >
          {question}
        </Typography>
        <Button
          onClick={(e) => { e.stopPropagation(); onToggle(); }}
          disableRipple
          sx={{ color: '#CF2230', minWidth: 'unset', p: '4px', flexShrink: 0 }}
        >
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </Button>
      </Box>

      <Collapse in={expanded}>
        <Box sx={{ px: '10px', pb: '12px' }}>
          {typeof answer === 'string' ? (
            <Typography sx={answerSx}>{answer}</Typography>
          ) : (
            answer
          )}
        </Box>
      </Collapse>
    </Box>
  );
}

export default function MajestorFAQ() {
  const [expanded, setExpanded] = useState(null);

  const handleToggle = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  return (
    <Container maxWidth="lg">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          py: { xs: '40px', md: '60px' },
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: '5.5vw', sm: '3.5vw', md: '2.08333vw' },
            color: '#CF2230',
            fontFamily: 'Gill Sans, Gill Sans MT, Calibri, sans-serif',
            fontWeight: 400,
            mb: { xs: '24px', md: '40px' },
            textAlign: 'center',
          }}
        >
          Frequently Asked Questions
        </Typography>

        <Box sx={{ width: { xs: '100%', md: '80%' } }}>
          {FAQ_DATA.map((item, index) => (
            <React.Fragment key={index}>
              <QuestionBox
                question={item.question}
                answer={item.answer}
                expanded={expanded === index}
                onToggle={() => handleToggle(index)}
              />
              {index < FAQ_DATA.length - 1 && (
                <Divider
             sx={{
                 margin: '10px 0',
                   backgroundColor: 'black',
                  height: '2px',
                   boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                 }}
              />
              )}
            </React.Fragment>
          ))}
        </Box>

      </Box>
      
    </Container>
  );
}